import { Component } from '@angular/core';

@Component({
    template: require('./page-internal-server-error.component.html'),
})
export class PageInternalServerErrorComponent { }
